import { findIndex } from 'lodash'
import { storeAssessor, deleteAssessor } from '@/api/super'

export default {

  namespaced: true,

  state: {
    assessor: {
      assessible_id: '',
      assessible_type: '',
      assessor_id: '',
      standards: []
    }
  },

  mutations: {
    clearAssessor: (state) => state.assessor = {
      assessible_id: '',
      assessible_type: '',
      assessor_id: '',
      standards: []
    },
    setAssessibleType: (state, payload) => state.assessor.assessible_type = payload,
    updateAssessibleId: (state, payload) => state.assessor.assessible_id = payload,
    updateAssessor: (state, payload) => state.assessor.assessor_id = payload,
    setStandards: (state, payload) => state.assessor.standards = payload,
    updateStandardSecureSetting: (state, payload) => {
      let index = findIndex(state.assessor.standards, section => section.id === payload.sectionId)
      let standard = state.assessor.standards[index]
      standard.setting.secure_setting = payload.value
      state.assessor.standards.splice(index, 1, standard)
    },
    clearAssessorSecureSettings: (state) => {
      state.assessor.standards = state.assessor.standards.map(standard => {
        standard.setting.secure_setting = null
        return standard
      })
    }
  },

  actions: {
    storeAssessor: ({state}, payload) => new Promise((resolve, reject) => {
      storeAssessor({
        ...payload,
        ...state.assessor
      }, resolve, reject)
    }),
    deleteAssessor: ({state}, assessorId) => new Promise((resolve, reject) => {
      deleteAssessor(assessorId, resolve, reject)
    })
  },

  getters: {
    assessor: state => state.assessor
  }

}